import React from "react"
import { PRICE, DISCOUNT, TAX, SUBTOTAL, TOTAL } from "../../constants/messages"
import _ from "../../utils/lodashUtils"
import "./CheckoutContent.scss"

//show both cart details on checkout with items and their price
const CheckoutContent = props => {
  const {
    cart,
    username,
    className,
    isOrderCombined,
    customOrderWrapper,
  } = props

  const renderOrderItem = () => {
    return (
      !_.isEmpty(cart) &&
      cart.map(
        ({ id, quantity, name, price, instructions, options }, index) => {
          return (
            <div id="orderDetail" key={`${id}-index-${index}`}>
              <div id="foodname">
                {quantity} {name}
                {options &&
                  options.map(option => {
                    return option.options.map(item => {
                      return (
                        <div
                          key={_.get(item, "id", "")}
                          className="instruction"
                        >
                          {_.get(item, "name", "")}
                        </div>
                      )
                    })
                  })}
                <div className="instruction">{instructions}</div>
              </div>
              <div id="priceContainer">
                <div id="price">{PRICE(Number(price).toFixed(2))}</div>
              </div>
            </div>
          )
        }
      )
    )
  }

  return (
    <div id="CheckoutContent">
      <div className="order-box">
        <div className="order-name">{username}</div>
        <div className={`separator ${className}`}></div>
        <div className={`${customOrderWrapper} order-item`}>
          {renderOrderItem()}
          {isOrderCombined && (
            <div className="sub-total">
              <div>{username} total</div>
              <div>{PRICE(Number(_.get(props, "subtotal", 0)).toFixed(2) )}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export const CheckoutPriceBreakdown = props => {
  const {
    tax = 0,
    subtotal = 0,
    total = 0,
    fees = 0,
    discount = 0,
    isOrderCombined = false,
    customOrderWrapper,
  } = props
  return (
    <div className={`${customOrderWrapper} order-item`}>
      {!isOrderCombined && (
        <div className="sub-total">
          <div>{SUBTOTAL}</div>
          <div>{PRICE(Number(subtotal).toFixed(2))}</div>
        </div>
      )}
      {!_.isEmpty(fees) &&
        fees.map((feeItem, index) => {
          if (+feeItem.value <= 0) {
            return null
          }
          return (
            <div key={index} className="discount">
              <span>{_.get(feeItem, "name", "")}</span>
              <span>${Number(_.get(feeItem, "value", 0)).toFixed(2)}</span>
            </div>
          )
        })}
      <div className="tax">
        <div>{TAX}</div>
        <div>{PRICE(Number(tax).toFixed(2))}</div>
      </div>
      <div className="discount">
        <div>{DISCOUNT}</div>
        <div>{PRICE(Number(discount).toFixed(2))}</div>
      </div>
      <div className="total-price">
        <div className="total">{TOTAL}</div>
        <div className="final-price">{PRICE(Number(total).toFixed(2))}</div>
      </div>
    </div>
  )
}

export default CheckoutContent
